import {
  EventEmitter,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  Output,
  Input,
  OnInit,
  ViewRef,
} from "@angular/core";
import { MediaMatcher } from "@angular/cdk/layout";
import { MenuItems } from "../../../shared/menu-items/menu-items";
import { CommonService } from "../../../shared/common.service";
import { StreamService } from "../../../../app/shared/stream.service";
import { NavigationStart, Router } from "@angular/router";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class AppSidebarComponent implements OnInit, OnDestroy {
  MENUITEMS = [
    {
      state: "admin-dashboard",
      name: "Dashboard",
      iconUrl: "assets/images/Dashboard_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Dashboard_icon_white.svg",
    },
    // { state: 'admin/coupon-list', name: 'Coupon', iconUrl:"assets/images/coupon_.svg", type: 'link', iconUrlActive:'assets/images/coupon_white.svg'},
    {
      state: "admin/user-list",
      name: "Manage User",
      iconUrl: "assets/images/Managers_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Managers_icon_white.svg",
    },
    // { state: 'admin/manager-list', name: 'Manage Manager', iconUrl:"assets/images/manager_grey.svg", type: 'link', iconUrlActive:'assets/images/manager_white.svg'},
    {
      state: "admin/vehicle-list",
      name: "Vehicle",
      iconUrl: "assets/images/vehicle_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/vehicle_white.svg",
    },
    {
      state: "admin/booking-list",
      name: "Booking",
      iconUrl: "assets/images/booking_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/booking_white.svg",
    },
    {
      state: "admin/driver",
      name: "Driver",
      iconUrl: "assets/images/driver_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/driver_white.svg",
    },
    {
      state: "admin/driver_payment",
      name: "Driver Payment",
      iconUrl: "assets/images/dollar_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/dollar_white.svg",
    },
    {
      state: "admin/revenue-list",
      name: "Revenue",
      iconUrl: "assets/images/inactive.svg",
      type: "link",
      iconUrlActive: "assets/images/active.svg",
    },
    // { state: 'admin/track', name: 'Track', iconUrl:"assets/images/driver_grey.svg", type: 'link', iconUrlActive:'assets/images/driver_white.svg'},
  ];
  MENUMANAGER = [
    {
      state: "manager/dashboard",
      name: "Dashboard",
      iconUrl: "assets/images/Dashboard_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Dashboard_icon_white.svg",
    },
    {
      state: "manager/list-employee",
      name: "Employees",
      iconUrl: "assets/images/Employees_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Employees_icon_color.svg",
    },
    {
      state: "manager/list-resource",
      name: "Resources",
      iconUrl: "assets/images/Resources_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Resources_icon_white.svg",
    },
    {
      state: "manager/list-assessment",
      name: "Worksheet",
      iconUrl: "assets/images/Assessment_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Assessment_icon_white.svg",
    },
    // { state: 'manager/change-password', name: 'Change Password ', iconUrl:"assets/images/folder_color.svg", type: 'navigate', iconUrlActive:'assets/images/folder_white.svg'},
    {
      state: "manager/all-skills",
      name: "Skill List ",
      iconUrl: "assets/images/Candidates_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Candidates_icon_white.svg",
    },
    // { state: 'manager/change-password', name: 'Change Password ', iconUrl:"assets/images/password_color.svg", type: 'navigate', iconUrlActive:'assets/images/password_white.svg'},
  ];
  MENUEMPLOYEE = [
    {
      state: "employee/dashboard",
      name: "Dashboard",
      iconUrl: "assets/images/Dashboard_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Dashboard_icon_white.svg",
    },
    {
      state: "employee/list-resource",
      name: "Resources",
      iconUrl: "assets/images/Resources_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Resources_icon_white.svg",
    },
    {
      state: "employee/list-assessment",
      name: "Worksheet",
      iconUrl: "assets/images/Assessment_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Assessment_icon_white.svg",
    },

    // { state: 'employee/change-password', name: 'Change Password ', iconUrl:"assets/images/password_color.svg", type: 'navigate', iconUrlActive:'assets/images/password_white.svg'},
  ];
  @Output() messageEvent = new EventEmitter<string>();
  @Input() isMobileActive: any;
  mobileQuery: MediaQueryList;
  isAllow: boolean = false;
  isPodcast: boolean = false;
  currentNavition = [];
  userData: any;
  userP: any;
  userG: any;
  userName: any;
  podcastVal: boolean = false;
  private _mobileQueryListener: () => void;
  decodedToken: any;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public common: CommonService,
    private streamService: StreamService,
    public router: Router
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url.startsWith("/main")) {
          this.menuItems;
        }
      }
    });
    this.mobileQuery = media.matchMedia("(min-width: 768px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnInit() {
    this.userData = this.common.getUser();
    if (this.userData.role == "admin") {
      this.currentNavition = this.MENUITEMS;
    }
    if (this.userData.role == "employee") {
      this.currentNavition = this.MENUEMPLOYEE;
    }
    if (this.userData.role == "manager") {
      this.currentNavition = this.MENUMANAGER;
    }
  }

  sendRouteVal(index) {
    this.streamService.streamMessage(index);
    // this.messageEvent.emit(index);
  }
  activeRoute(index) {
    localStorage.setItem("activeIndex", index);
    this.sendRouteVal(index);
  }

  readLocalStorageValue(key: string): number {
    return parseInt(localStorage.getItem(key));
  }
  logOut() {
    this.common.logOut();
  }
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  active(index) {
    setTimeout(() => {
      localStorage.setItem("activeIndex", index);
      this.detectChanges();
      this.ngOnDestroy();
    }, 280);
  }
  detectChanges() {
    // Programmatically run change detection to fix issue in Safari
    setTimeout(() => {
      // this.isLoading = true;
      if (
        this.changeDetectorRef !== null &&
        this.changeDetectorRef !== undefined &&
        !(this.changeDetectorRef as ViewRef).destroyed
      ) {
        this.changeDetectorRef.detectChanges();
        // this.isLoading = false;
      }
    }, 580);
  }
}
